import { color } from "./colours";

export const textSelection = `
  ::selection {
    background: ${color.P20};
  }
`;
